
 <app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="variantes.oui" 
 
[label]="'oui'"
[rule]="'pattern_29'"
[type]="'radio'"
[value]="radioButtonValue"
[name]="radioButtonCtrlName"
[radios]="[
						{
                            value: oui,
							label: 'step1.getoui'
						},
						{
							value: non,
							label: 'step1.getnon'
						}
						]">
</app-form-input>
